import {ListAccessAdministrationRolesQueryParams} from "@project/sdk/access-administration/zod";
import type {z} from "zod";

export const listRolesSearchSchema = ListAccessAdministrationRolesQueryParams.extend({
  page: ListAccessAdministrationRolesQueryParams.shape.page.catch(1).default(1),
  perPage: ListAccessAdministrationRolesQueryParams.shape.perPage.catch(20).default(20),
  q: ListAccessAdministrationRolesQueryParams.shape.q.catch(undefined),
});
export type ListRolesSearchInput = z.input<typeof listRolesSearchSchema>;
export type ListRolesSearch = z.output<typeof listRolesSearchSchema>;
